// Status → Tailwind class lookups for badge styling.
// Centralised here to replace inline nested ternaries across pages.

const BASE_BADGE = "px-2.5 py-0.5 text-xs uppercase tracking-wider font-semibold";

export function invoiceBadgeClass(status) {
  let colour = "bg-orange-100 text-orange-800";
  if (status === "paid") {
    colour = "bg-green-100 text-green-800";
  } else if (status === "overdue") {
    colour = "bg-red-100 text-red-800";
  }
  return `${BASE_BADGE} ${colour}`;
}

// Display label: distinguishes manual (cash) vs online (Razorpay) payments,
// and marks past-due pending invoices as overdue.
export function invoiceStatusLabel(inv, today) {
  if (inv.status === "paid") {
    return inv.payment_method === "razorpay" ? "Paid · Razorpay" : "Paid · Manual";
  }
  if (inv.status === "overdue") return "Overdue";
  if (today && inv.due_date && inv.due_date < today) return "Overdue";
  return "Pending";
}

export function complaintBadgeClass(status) {
  let colour = "bg-orange-100 text-orange-800";
  if (status === "resolved") {
    colour = "bg-green-100 text-green-800";
  } else if (status === "in_progress") {
    colour = "bg-blue-100 text-blue-800";
  }
  return `${BASE_BADGE} whitespace-nowrap ${colour}`;
}

export function priorityBadgeClass(priority) {
  let colour = "bg-slate-100 text-slate-700";
  if (priority === "high") {
    colour = "bg-red-100 text-red-800";
  } else if (priority === "medium") {
    colour = "bg-orange-100 text-orange-800";
  }
  return `px-2 py-0.5 text-xs uppercase tracking-wider ${colour}`;
}
